const INITIAL_STATE = {
  triggeranyevent: "1",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_TRIGGERANYEVENT":
      return { ...state, triggeranyevent: action.payload };

    default:
      return state;
  }
};
